import React from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import { shell } from "../services/shell";
import { appStore } from "../services/app-store";
import { AppInfo } from "../models";

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  background: #333;
`;

const AppLink = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 10rem;
  max-width: 15rem;
  > a {
    color: #e0e0e0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

interface RelatedAppsProps {}

interface RelatedAppsState {
  apps: AppInfo[];
}

class RelatedApps extends React.Component<RelatedAppsProps, RelatedAppsState> {
  private _unsubscribes: Array<any>;
  private _hoverOnHotspot: boolean;
  private _barHeightPx: number = 50;
  private _horzScrollHeightPx: number = 20;
  constructor(props: RelatedAppsProps) {
    super(props);

    this.state = { apps: [] };
    this._unsubscribes = [];
    this._unsubscribes.push(shell.appOpenedEvent.subscribe((_: any) => this.getRelatedApps()));
    this._unsubscribes.push(appStore.changedEvent.subscribe((_: any) => this.getRelatedApps()));

    document.addEventListener("mousemove", this.handleDocMouseMove.bind(this));
  }

  static componentTypes = {
    AppLink
  };

  getRelatedApps() {
    this.setState({ apps: shell.getRelatedApps() });
  }

  handleDocMouseMove(e: React.MouseEvent) {
    if (!this.state.apps.length) return;

    const hoverOnHotspot = e.clientY > window.innerHeight - (this._barHeightPx + this._horzScrollHeightPx);

    if (this._hoverOnHotspot !== hoverOnHotspot) {
      this._hoverOnHotspot = hoverOnHotspot;
      if (hoverOnHotspot) this.showBar();
      else this.hideBar();
    }
  }

  showBar() {
    const navElem = document.querySelector("#AppContainer main > nav") as HTMLElement;
    const barElem = document.getElementById("RelatedAppsBar");

    if (barElem.classList.contains("hide")) return;

    if (navElem && (navElem.offsetWidth > 0 || navElem.classList.contains("show"))) barElem.classList.add("nav-offset");
    else barElem.classList.remove("nav-offset");

    barElem.style.visibility = "visible";
    barElem.classList.add("show");

    // Find the flex DOM element inside the app that overlaps with the apps bar to add a bottom margin to shift it up.
    // If the logic isn't good enough, override by manually setting "apps-bar-overlap" css class on the correct element.
    let overlaps = Array.from(document.querySelectorAll(".apps-bar-overlap"));
    if (!overlaps.length && document.elementsFromPoint /* not supported in IE11 */) {
      const appContainer = document.getElementById("AppContainer");
      const rect = barElem.getBoundingClientRect();
      const overlap = document
        .elementsFromPoint(rect.x + rect.width / 2, rect.y + rect.height / 2)
        .reverse()
        .find((x: HTMLElement) => appContainer.contains(x) && getComputedStyle(x).display === "flex");

      if (overlap) {
        overlap.classList.add("apps-bar-overlap");
        overlaps = [overlap];
      }
    }
    overlaps?.forEach(x => x.classList.add("apps-bar-margin"));
  }

  hideBar() {
    const barElem = document.getElementById("RelatedAppsBar");
    barElem.classList.remove("show");
    setTimeout(() => (barElem.style.visibility = "hidden"), 250);
    const overlaps = Array.from(document.querySelectorAll(".apps-bar-margin"));
    overlaps.forEach(x => x.classList.remove("apps-bar-margin"));
  }

  componentWillUnmount() {
    this._unsubscribes.map(x => x());
    document.removeEventListener("mousemove", this.handleDocMouseMove.bind(this));
  }

  render() {
    const { apps } = this.state;
    const relatedApps = apps.map(app => (
      <AppLink key={app.id}>
        <a href="javascript:void(0)" tabIndex={-1} onClick={_ => shell.openApp(app.id)}>
          <span className={"app-icon mi-icat-icon mi-small mi-icon-" + app.iconLigature} />
          {app.displayName}
        </a>
      </AppLink>
    ));

    return (
      <React.Fragment>
        <Container onClick={this.hideBar}>
          {relatedApps}
          <AppLink>
            <a href="javascript:void(0)" tabIndex={-1} onClick={_ => shell.openMainMenu()}>
              <span className="app-icon mi-icat-icon mi-small mi-icon-large-thumbnail-view" />
              Home
            </a>
          </AppLink>
        </Container>
      </React.Fragment>
    );
  }
}

ReactDOM.render(<RelatedApps />, document.getElementById("RelatedAppsBar"));
